import React from 'react';
import { connect } from 'react-redux';
import { Card, Col } from 'react-bootstrap';
import PropertyPickerVertical from './components/PropertyPickerVertical';
import BaseFeature from './BaseFeature';
import { TEMPERATURE_DEPENDENCIES } from '../../../../../../utils/constantFeatures';

class TemperatureDependencies extends BaseFeature {

    constructor() {
        super();

        this.state = {};

        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(propertyName, value) {

        this.props.handleChange(propertyName, value);
    }

    render() {

        const temperatureMinCh0 = this.props.properties[TEMPERATURE_DEPENDENCIES.temperatureMinCh0];
        const temperatureMinCh1 = this.props.properties[TEMPERATURE_DEPENDENCIES.temperatureMinCh1];
        const temperatureMedCh0 = this.props.properties[TEMPERATURE_DEPENDENCIES.temperatureMedCh0];
        const temperatureMedCh1 = this.props.properties[TEMPERATURE_DEPENDENCIES.temperatureMedCh1];
        const temperatureMaxCh0 = this.props.properties[TEMPERATURE_DEPENDENCIES.temperatureMaxCh0];
        const temperatureMaxCh1 = this.props.properties[TEMPERATURE_DEPENDENCIES.temperatureMaxCh1];

        const luminousFluxTemperatureMinCh0 = this.props.properties[TEMPERATURE_DEPENDENCIES.luminousFluxTemperatureMinCh0];
        const luminousFluxTemperatureMinCh1 = this.props.properties[TEMPERATURE_DEPENDENCIES.luminousFluxTemperatureMinCh1];
        const luminousFluxTemperatureMedCh0 = this.props.properties[TEMPERATURE_DEPENDENCIES.luminousFluxTemperatureMedCh0];
        const luminousFluxTemperatureMedCh1 = this.props.properties[TEMPERATURE_DEPENDENCIES.luminousFluxTemperatureMedCh1];
        const luminousFluxTemperatureMaxCh0 = this.props.properties[TEMPERATURE_DEPENDENCIES.luminousFluxTemperatureMaxCh0];
        const luminousFluxTemperatureMaxCh1 = this.props.properties[TEMPERATURE_DEPENDENCIES.luminousFluxTemperatureMaxCh1];

        const colourCoordinateTemperatureXMinCh0 = this.props.properties[TEMPERATURE_DEPENDENCIES.colourCoordinateTemperatureXMinCh0];
        const colourCoordinateTemperatureXMinCh1 = this.props.properties[TEMPERATURE_DEPENDENCIES.colourCoordinateTemperatureXMinCh1];
        const colourCoordinateTemperatureXMedCh0 = this.props.properties[TEMPERATURE_DEPENDENCIES.colourCoordinateTemperatureXMedCh0];
        const colourCoordinateTemperatureXMedCh1 = this.props.properties[TEMPERATURE_DEPENDENCIES.colourCoordinateTemperatureXMedCh1];
        const colourCoordinateTemperatureXMaxCh0 = this.props.properties[TEMPERATURE_DEPENDENCIES.colourCoordinateTemperatureXMaxCh0];
        const colourCoordinateTemperatureXMaxCh1 = this.props.properties[TEMPERATURE_DEPENDENCIES.colourCoordinateTemperatureXMaxCh1];

        const colourCoordinateTemperatureYMinCh0 = this.props.properties[TEMPERATURE_DEPENDENCIES.colourCoordinateTemperatureYMinCh0];
        const colourCoordinateTemperatureYMinCh1 = this.props.properties[TEMPERATURE_DEPENDENCIES.colourCoordinateTemperatureYMinCh1];
        const colourCoordinateTemperatureYMedCh0 = this.props.properties[TEMPERATURE_DEPENDENCIES.colourCoordinateTemperatureYMedCh0];
        const colourCoordinateTemperatureYMedCh1 = this.props.properties[TEMPERATURE_DEPENDENCIES.colourCoordinateTemperatureYMedCh1];
        const colourCoordinateTemperatureYMaxCh0 = this.props.properties[TEMPERATURE_DEPENDENCIES.colourCoordinateTemperatureYMaxCh0];
        const colourCoordinateTemperatureYMaxCh1 = this.props.properties[TEMPERATURE_DEPENDENCIES.colourCoordinateTemperatureYMaxCh1];

        console.log(this.props.properties);

        return (
            <div>
                <div className="flex-row" style={{ paddingTop: '0.75rem' }}>
                    <Card className={this.getClassName(
                        [temperatureMinCh0, temperatureMedCh0, temperatureMaxCh0,
                            luminousFluxTemperatureMinCh0, luminousFluxTemperatureMedCh0, luminousFluxTemperatureMaxCh0,
                            colourCoordinateTemperatureXMinCh0, colourCoordinateTemperatureXMedCh0, colourCoordinateTemperatureXMaxCh0,
                            colourCoordinateTemperatureYMinCh0, colourCoordinateTemperatureYMedCh0, colourCoordinateTemperatureYMaxCh0])}>
                        <div className="card-header-feature" style={{ margin: "-1rem auto 0" }}>
                            {'Cold White'}
                        </div>
                        <Card.Body style={{ display: "flex" }} disabled={!this.state.isEnabled}>

                            <Col className={"Col-PropertyPickerVertical"}>
                                <PropertyPickerVertical
                                    property={temperatureMinCh0}
                                    border={'border-none'}
                                    title={"Temperature Minimum"}
                                    measureUnit={temperatureMinCh0.info.unit}
                                    min={temperatureMinCh0.valueMeta.min}
                                    max={temperatureMinCh0.valueMeta.max}
                                    step={1}
                                    handleChange={this.handleChange} />
                                <PropertyPickerVertical
                                    property={temperatureMedCh0}
                                    border={'border-none'}
                                    title={"Temperature Medium"}
                                    measureUnit={temperatureMedCh0.info.unit}
                                    min={temperatureMedCh0.valueMeta.min}
                                    max={temperatureMedCh0.valueMeta.max}
                                    step={1}
                                    handleChange={this.handleChange} />
                                <PropertyPickerVertical
                                    property={temperatureMaxCh0}
                                    border={'border-none'}
                                    title={"Temperature Maximum"}
                                    measureUnit={temperatureMaxCh0.info.unit}
                                    min={temperatureMaxCh0.valueMeta.min}
                                    max={temperatureMaxCh0.valueMeta.max}
                                    step={1}
                                    handleChange={this.handleChange} />

                            </Col>
                            <Col className={"Col-PropertyPickerVertical"}>

                                <PropertyPickerVertical
                                    property={luminousFluxTemperatureMinCh0}
                                    border={'border-none'}
                                    title={"Luminous Flux Minimum"}
                                    measureUnit={luminousFluxTemperatureMinCh0.info.unit}
                                    min={luminousFluxTemperatureMinCh0.valueMeta.min}
                                    max={luminousFluxTemperatureMinCh0.valueMeta.max}
                                    type={'float'}
                                    step={0.01}
                                    handleChange={this.handleChange} />
                                <PropertyPickerVertical
                                    property={luminousFluxTemperatureMedCh0}
                                    border={'border-none'}
                                    title={"Luminous Flux Medium"}
                                    measureUnit={luminousFluxTemperatureMedCh0.info.unit}
                                    min={luminousFluxTemperatureMedCh0.valueMeta.min}
                                    max={luminousFluxTemperatureMedCh0.valueMeta.max}
                                    type={'float'}
                                    step={0.01}
                                    handleChange={this.handleChange} />
                                <PropertyPickerVertical
                                    property={luminousFluxTemperatureMaxCh0}
                                    border={'border-none'}
                                    title={"Luminous Flux Maximum"}
                                    measureUnit={luminousFluxTemperatureMaxCh0.info.unit}
                                    min={luminousFluxTemperatureMaxCh0.valueMeta.min}
                                    max={luminousFluxTemperatureMaxCh0.valueMeta.max}
                                    type={'float'}
                                    step={0.01}
                                    handleChange={this.handleChange} />
                            </Col>
                            <Col className={"Col-PropertyPickerVertical"}>
                                <PropertyPickerVertical
                                    property={colourCoordinateTemperatureXMinCh0}
                                    border={'border-none'}
                                    title={"Colour Coordinate x Minimum"}
                                    type={'float'}
                                    step={0.0001}
                                    measureUnit={colourCoordinateTemperatureXMinCh0.info.unit}
                                    min={colourCoordinateTemperatureXMinCh0.valueMeta.min}
                                    max={colourCoordinateTemperatureXMinCh0.valueMeta.max}
                                    handleChange={this.handleChange} />
                                <PropertyPickerVertical
                                    property={colourCoordinateTemperatureXMedCh0}
                                    border={'border-none'}
                                    title={"Colour Coordinate x Medium"}
                                    type={'float'}
                                    step={0.0001}
                                    measureUnit={colourCoordinateTemperatureXMedCh0.info.unit}
                                    min={colourCoordinateTemperatureXMedCh0.valueMeta.min}
                                    max={colourCoordinateTemperatureXMedCh0.valueMeta.max}
                                    handleChange={this.handleChange} />
                                <PropertyPickerVertical
                                    property={colourCoordinateTemperatureXMaxCh0}
                                    border={'border-none'}
                                    title={"Colour Coordinate x Maximum"}
                                    type={'float'}
                                    step={0.0001}
                                    measureUnit={colourCoordinateTemperatureXMaxCh0.info.unit}
                                    min={colourCoordinateTemperatureXMaxCh0.valueMeta.min}
                                    max={colourCoordinateTemperatureXMaxCh0.valueMeta.max}
                                    handleChange={this.handleChange} />

                            </Col>
                            <Col className={"Col-PropertyPickerVertical"}>
                                <PropertyPickerVertical
                                    property={colourCoordinateTemperatureYMinCh0}
                                    border={'border-none'}
                                    title={"Colour Coordinate y Minimum"}
                                    type={'float'}
                                    step={0.0001}
                                    measureUnit={colourCoordinateTemperatureYMinCh0.info.unit}
                                    min={colourCoordinateTemperatureYMinCh0.valueMeta.min}
                                    max={colourCoordinateTemperatureYMinCh0.valueMeta.max}
                                    handleChange={this.handleChange} />
                                <PropertyPickerVertical
                                    property={colourCoordinateTemperatureYMedCh0}
                                    border={'border-none'}
                                    title={"Colour Coordinate y Medium"}
                                    type={'float'}
                                    step={0.0001}
                                    measureUnit={colourCoordinateTemperatureYMedCh0.info.unit}
                                    min={colourCoordinateTemperatureYMedCh0.valueMeta.min}
                                    max={colourCoordinateTemperatureYMedCh0.valueMeta.max}
                                    handleChange={this.handleChange} />
                                <PropertyPickerVertical
                                    property={colourCoordinateTemperatureYMaxCh0}
                                    border={'border-none'}
                                    title={"Colour Coordinate y Maximum"}
                                    type={'float'}
                                    step={0.0001}
                                    measureUnit={colourCoordinateTemperatureYMaxCh0.info.unit}
                                    min={colourCoordinateTemperatureYMaxCh0.valueMeta.min}
                                    max={colourCoordinateTemperatureYMaxCh0.valueMeta.max}
                                    handleChange={this.handleChange} />

                            </Col>
                        </Card.Body>
                    </Card>
                </div>
                <div className="flex-row" style={{ paddingTop: '0.75rem' }}>
                    <Card className={this.getClassName(
                        [temperatureMinCh1, temperatureMedCh1, temperatureMaxCh1,
                            luminousFluxTemperatureMinCh1, luminousFluxTemperatureMedCh1, luminousFluxTemperatureMaxCh1,
                            colourCoordinateTemperatureXMinCh1, colourCoordinateTemperatureXMedCh1, colourCoordinateTemperatureXMaxCh1,
                            colourCoordinateTemperatureYMinCh1, colourCoordinateTemperatureYMedCh1, colourCoordinateTemperatureYMaxCh1])}>
                        <div className="card-header-feature" style={{ margin: "-1rem auto 0" }}>
                            {'Warm White'}
                        </div>
                        <Card.Body style={{ display: "flex" }} disabled={!this.state.isEnabled}>

                            <Col className={"Col-PropertyPickerVertical"}>
                                <PropertyPickerVertical
                                    property={temperatureMinCh1}
                                    border={'border-none'}
                                    title={"Temperature Minimum"}
                                    measureUnit={temperatureMinCh1.info.unit}
                                    min={temperatureMinCh1.valueMeta.min}
                                    max={temperatureMinCh1.valueMeta.max}
                                    step={1}
                                    handleChange={this.handleChange} />
                                <PropertyPickerVertical
                                    property={temperatureMedCh1}
                                    border={'border-none'}
                                    title={"Temperature Medium"}
                                    measureUnit={temperatureMedCh1.info.unit}
                                    min={temperatureMedCh1.valueMeta.min}
                                    max={temperatureMedCh1.valueMeta.max}
                                    step={1}
                                    handleChange={this.handleChange} />
                                <PropertyPickerVertical
                                    property={temperatureMaxCh1}
                                    border={'border-none'}
                                    title={"Temperature Maximum"}
                                    measureUnit={temperatureMaxCh1.info.unit}
                                    min={temperatureMaxCh1.valueMeta.min}
                                    max={temperatureMaxCh1.valueMeta.max}
                                    step={1}
                                    handleChange={this.handleChange} />

                            </Col>
                            <Col className={"Col-PropertyPickerVertical"}>
                                <PropertyPickerVertical
                                    property={luminousFluxTemperatureMinCh1}
                                    border={'border-none'}
                                    title={"Luminous Flux Minimum"}
                                    measureUnit={luminousFluxTemperatureMinCh1.info.unit}
                                    min={luminousFluxTemperatureMinCh1.valueMeta.min}
                                    max={luminousFluxTemperatureMinCh1.valueMeta.max}
                                    type={'float'}
                                    step={0.01}
                                    handleChange={this.handleChange} />
                                <PropertyPickerVertical
                                    property={luminousFluxTemperatureMedCh1}
                                    border={'border-none'}
                                    title={"Luminous Flux Medium"}
                                    measureUnit={luminousFluxTemperatureMedCh1.info.unit}
                                    min={luminousFluxTemperatureMedCh1.valueMeta.min}
                                    max={luminousFluxTemperatureMedCh1.valueMeta.max}
                                    type={'float'}
                                    step={0.01}
                                    handleChange={this.handleChange} />
                                <PropertyPickerVertical
                                    property={luminousFluxTemperatureMaxCh1}
                                    border={'border-none'}
                                    title={"Luminous Flux Maximum"}
                                    measureUnit={luminousFluxTemperatureMaxCh1.info.unit}
                                    min={luminousFluxTemperatureMaxCh1.valueMeta.min}
                                    max={luminousFluxTemperatureMaxCh1.valueMeta.max}
                                    type={'float'}
                                    step={0.01}
                                    handleChange={this.handleChange} />
                            </Col>
                            <Col className={"Col-PropertyPickerVertical"}>
                                <PropertyPickerVertical
                                    property={colourCoordinateTemperatureXMinCh1}
                                    border={'border-none'}
                                    title={"Colour Coordinate x Minimum"}
                                    type={'float'}
                                    step={0.0001}
                                    measureUnit={colourCoordinateTemperatureXMinCh1.info.unit}
                                    min={colourCoordinateTemperatureXMinCh1.valueMeta.min}
                                    max={colourCoordinateTemperatureXMinCh1.valueMeta.max}
                                    handleChange={this.handleChange} />
                                <PropertyPickerVertical
                                    property={colourCoordinateTemperatureXMedCh1}
                                    border={'border-none'}
                                    title={"Colour Coordinate x Medium"}
                                    type={'float'}
                                    step={0.0001}
                                    measureUnit={colourCoordinateTemperatureXMedCh1.info.unit}
                                    min={colourCoordinateTemperatureXMedCh1.valueMeta.min}
                                    max={colourCoordinateTemperatureXMedCh1.valueMeta.max}
                                    handleChange={this.handleChange} />
                                <PropertyPickerVertical
                                    property={colourCoordinateTemperatureXMaxCh1}
                                    border={'border-none'}
                                    title={"Colour Coordinate x Maximum"}
                                    type={'float'}
                                    step={0.0001}
                                    measureUnit={colourCoordinateTemperatureXMaxCh1.info.unit}
                                    min={colourCoordinateTemperatureXMaxCh1.valueMeta.min}
                                    max={colourCoordinateTemperatureXMaxCh1.valueMeta.max}
                                    handleChange={this.handleChange} />

                            </Col>


                            <Col className={"Col-PropertyPickerVertical"}>
                                <PropertyPickerVertical
                                    property={colourCoordinateTemperatureYMinCh1}
                                    border={'border-none'}
                                    title={"Colour Coordinate y Minimum"}
                                    type={'float'}
                                    step={0.0001}
                                    measureUnit={colourCoordinateTemperatureYMinCh1.info.unit}
                                    min={colourCoordinateTemperatureYMinCh1.valueMeta.min}
                                    max={colourCoordinateTemperatureYMinCh1.valueMeta.max}
                                    handleChange={this.handleChange} />
                                <PropertyPickerVertical
                                    property={colourCoordinateTemperatureYMedCh1}
                                    border={'border-none'}
                                    title={"Colour Coordinate y Medium"}
                                    type={'float'}
                                    step={0.0001}
                                    measureUnit={colourCoordinateTemperatureYMedCh1.info.unit}
                                    min={colourCoordinateTemperatureYMedCh1.valueMeta.min}
                                    max={colourCoordinateTemperatureYMedCh1.valueMeta.max}
                                    handleChange={this.handleChange} />
                                <PropertyPickerVertical
                                    property={colourCoordinateTemperatureYMaxCh1}
                                    border={'border-none'}
                                    title={"Colour Coordinate y Maximum"}
                                    type={'float'}
                                    step={0.0001}
                                    measureUnit={colourCoordinateTemperatureYMaxCh1.info.unit}
                                    min={colourCoordinateTemperatureYMaxCh1.valueMeta.min}
                                    max={colourCoordinateTemperatureYMaxCh1.valueMeta.max}
                                    handleChange={this.handleChange} />
                            </Col>
                        </Card.Body>
                    </Card>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
    };
};

const mapDispatchToProps = {
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(TemperatureDependencies);